<div class="container">
    <div class="text-center">
        <strong class="mainHeading">Menu Configuration</strong>
    </div>
</div>

<div class="row mt-3">
    <div class="col-lg-9 col-md-9 col-sm-12 toolbar d-flex align-items-center gap-2">
        <button class="btn btn-success btn" (click)="openCreateMenuModal(createMenuModal)" ngbTooltip="Add Menu"
            tooltipClass="custom-tooltip"><span><i class="bi bi-plus me-2"></i></span>Add Menu</button>
        <button class="btn btn-success btn" (click)="openSubmenuModal(createSubMenuModal)"
            ngbTooltip="Add Submenu"><span><i class="bi bi-plus me-2"></i></span>
            Add Submenu</button>
    </div>
</div>

<div class="card shadow-lg p-4 mt-4">
    <div class="table-responsive">
        <table class="table table-striped table-bordered text-center table-hover mb-0">
            <thead class="table-light">
                <tr>
                    <th></th>
                    <th>Main Menu</th>
                    <!-- <th>Menu URL</th> -->
                    <th>Menu Icon</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let menu of sideMenuList">
                    <tr>
                        <td class="text-center" (click)="toggleSubmenu(menu)">
                            <i class="bi" [ngClass]="menu.expanded ? 'bi-caret-down-fill' : 'bi-caret-right-fill'"
                                style="cursor: pointer;">
                            </i>
                        </td>
                        <td class="text-center">{{ menu.menuName }}</td>
                        <!-- <td class="text-center">{{ menu.menuURL }}</td> -->
                        <td class="text-center">{{ menu.menuIcon }}</td>
                        <td class="text-center">
                            <a class="hyperLink" (click)="editMainMenu(menu, createMenuModal)">Edit</a> <span> / </span>
                            <a (click)="openDeleteModal(menu, deleteModal)" class=" hyperLink">Delete</a>
                        </td>
                    </tr>

                    <!-- Submenu Rows Inside Parent -->
                    <tr *ngIf="menu.expanded">
                        <td colspan="5">
                            <div class="submenu-container">
                                <table class="table table-bordered text-center submenu-table">
                                    <thead class="table-light">
                                        <tr>
                                            <th>S No</th>
                                            <th>Submenu Name</th>
                                            <th>Submenu URL</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let submenu of menu.submenus; let i = index">
                                            <td class="text-center">{{ i + 1 }}</td>
                                            <td class="text-start">{{ submenu.subMenuName }}</td>
                                            <td class="text-center">{{ submenu.subMenuUrl }}</td>
                                            <td class="text-center">
                                                <a class="hyperLink"
                                                    (click)="editSubMenu(menu, submenu, createSubMenuModal)">Edit</a>
                                                <span> /
                                                </span> <a (click)="openSubMenuDeleteModal(submenu, deleteModal)"
                                                    class=" hyperLink">Delete</a>
                                            </td>
                                        </tr>
                                        <tr *ngIf="menu.submenus.length === 0">
                                            <td colspan="4" class="text-center">No Data Found</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>

<!-- Create Menu Modal -->
<ng-template #createMenuModal let-modal>
    <div class="modal-header custom-modal-header">
        <h2 class="modal-title mt-3">{{ isEditMode ? 'Edit Menu' : 'Add Menu' }}</h2>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="form">
            <div class="p-2">
                <div class="mb-3">
                    <label class="form-label">Menu Name</label>
                    <input type="text" class="form-control" formControlName="menuName"
                        [ngClass]="{ 'is-invalid': form.get('menuName')?.invalid && form.get('menuName')?.touched }">
                </div>
                <div class="mb-3">
                    <label class="form-label">Menu URL</label>
                    <input type="text" class="form-control" formControlName="menuUrl"
                        [ngClass]="{ 'is-invalid': form.get('menuUrl')?.invalid && form.get('menuUrl')?.touched }">
                </div>
                <div class="mb-3">
                    <label class="form-label me-2">Icon Name</label>
                    <input type="text" class="form-control" formControlName="iconName"
                        [ngClass]="{ 'is-invalid': form.get('iconName')?.invalid && form.get('iconName')?.touched }">
                </div>

            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="submitForm(isEditMode ? 'edit' : 'new')">
            <i class="bi" [ngClass]="isEditMode ? 'bi-plus-square' : 'bi-check-lg'"></i>
            {{ isEditMode ? ' Update' : ' Submit' }}
        </button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
            <i class="bi bi-x-lg"></i> Close
        </button>
    </div>

</ng-template>

<ng-template #createSubMenuModal let-modal>
    <div class="modal-header custom-modal-header">
        <h2 class="modal-title mt-3">{{ isEditMode ? 'Edit Sub Menu' : 'Add Sub Menu' }}</h2>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="subMenuForm">
            <div class="p-2">
                <div class="mb-3">
                    <label class="form-label">Main Menu</label>
                    <select type="text" class="form-select" formControlName="mainMenu" (change)="onMenuChange($event)">
                        <option [value]="menu.id" *ngFor="let menu of sideMenuList">{{ menu.menuName }}</option>
                    </select>
                </div>
                <div class="mb-3">
                    <label class="form-label">Submenu Name</label>
                    <input type="text" class="form-control" formControlName="submenuName">
                </div>
                <div class="mb-3">
                    <label class="form-label">Submenu URL</label>
                    <input type="text" class="form-control" formControlName="submenuUrl">
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="submitSubmenuForm(isEditMode ? 'Update' : 'Submit')">
            <i class="bi" [ngClass]="isEditMode ? 'bi-plus-square' : 'bi-check-lg'"></i>
            {{ isEditMode ? ' Update' : ' Submit' }}
        </button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
            <i class="bi bi-x-lg"></i> Close
        </button>
    </div>
</ng-template>

<ng-template #deleteModal let-modal>
    <div class="modal-header custom-modal-header">
        <h3 class="modal-title mt-3">Confirm Deletion</h3>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <p>Are you sure you want to delete <strong>{{ isEditMode ? selectedSubMenu.subMenuName : selectedMenu?.menuName
                }}</strong>?</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" *ngIf="isMainMenu"
            (click)="deleteMainMenu()">Delete</button>
        <button type="button" class="btn btn-danger" *ngIf="!isMainMenu"
            (click)="deleteSubMenu()">Delete</button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    </div>
</ng-template>